
import axios from './axios'
import {User  } from '@/../../EshJSLib/models/patient'

export async function destroyUser() {
    
    const response = await axios.put(`/api/destroyUser`);
    return response.data;
}

export async function registerOnMobile(data: any) {
    const response = await axios.post('api/user/registerMobile', data);
    return response;
}